.ai{overflow:hidden;}